import * as React from "react";

import { TFormControlProps } from "kanopi-components/Input";
import { IntegerInput } from "./IntegerInput";

type TProps = {
  help: string;
  step?: number;
} & TFormControlProps;

export const FloatInput: React.FC<TProps> = ({ step = 0.01, ...props }) => {
  return <IntegerInput step={step} {...props} />;
};
